import React, { useEffect, useRef, useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Image } from "react-bootstrap";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import axios from "axios";
import { thumbnail } from "./ImageResizerComponent";
import {
  imageUploadSize,
  serverApi,
  SliderSettings,
} from "../../../config/Keys";
import { errorAlert, successAlert } from "../../../function/alert";
import Slider from "react-slick";
import CloseIcon from "@material-ui/icons/Close";

export const base64toBlob = (data) => {
  // Cut the prefix `data:application/pdf;base64` from the raw base 64
  const base64WithoutPrefix = data.substr("data:image/png;base64,".length);

  const bytes = atob(base64WithoutPrefix);
  let length = bytes.length;
  let out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  return new Blob([out], { type: "image/png" });
};

export const ReactCropperImage = ({ combined, value, onComplete, image }) => {
  const cropperRef = useRef(null);
  const [_image, setImage] = useState("");
  const [open, setOpen] = useState(true);
  const [cropper, setCropper] = useState();
  const [progress, setProgress] = React.useState(0);

  useEffect(() => {
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
      setOpen(true);
    };
    reader.readAsDataURL(image);
  }, [image]);
  const onCrop = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    cropper.getCroppedCanvas().toDataURL("image/png");
  };

  const getCropData = async () => {
    try {
      if (typeof cropper !== "undefined") {
        let base_64 = cropper.getCroppedCanvas().toDataURL("image/png");
        let file = await base64toBlob(base_64);
        var newfile = new File([file], `${image.name}`, {
          type: "image/png",
        });

        var data = new FormData();
        data.append("files", newfile);

        // Thumbnail upload
        let thumb = await thumbnail(newfile);
        let thumbFile = new File([thumb], `thumbnail/${image.name}`, {
          type: "image/png",
        });
        let thumbData = new FormData();
        thumbData.append("files", thumbFile);
        let thumbnails = await axios.post(
          `${serverApi}/upload-assets?uploadSide=${combined}&thumbnail=true`,
          thumbData
          // {
          //   onUploadProgress: (progressEvent) =>
          //     setProgress((progressEvent.loaded / progressEvent.total) * 100),
          // }
        );

        //   API CALL
        await axios
          .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) =>
              setProgress((progressEvent.loaded / progressEvent.total) * 100),
          })
          .then((res) => {
            successAlert("Upload Success");
            onComplete(res.data, thumbnails.data);
            setProgress(0);
            setOpen(false);
          })
          .catch((err) => {
            errorAlert("Upload Failed");
            setProgress(0);
            setOpen(false);
          });
      } else {
        setOpen(false);
        errorAlert("Image not supported");
      }
    } catch (err) {
      setOpen(false);
      errorAlert("Image not supported");
    }
  };

  try {
    return (
      <div className="file_upload mt-3 mb-3">
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Crop Image</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {progress !== 0 ? (
                <div
                  className="progress image-upload-progress-mobile"
                  style={{ minWidth: "450px" }}
                >
                  <div
                    className="progress-bar bg-success"
                    style={{ width: `${progress}%` }}
                  >
                    {Math.floor(progress)}% Uploaded{" "}
                  </div>
                </div>
              ) : (
                <>
                  <Cropper
                    src={_image}
                    style={{ height: "100%", width: "100%" }}
                    zoomTo={0}
                    // initialAspectRatio={16 / 9}
                    guides={false}
                    crop={onCrop}
                    // preview=".img-preview"
                    viewMode={1}
                    ref={cropperRef}
                    minCropBoxHeight={10}
                    minCropBoxWidth={10}
                    onInitialized={(instance) => {
                      setCropper(instance);
                    }}
                  />
                  {/* <div
                    className="img-preview"
                    style={{ width: "300px", height: "100%" }}
                  /> */}
                  <div className="d-flex justify-content-end mt-4">
                    <Button
                      type="button"
                      color="secondary"
                      className="mr-2"
                      onClick={() => setOpen(false)}
                    >
                      Cancel
                    </Button>

                    <Button type="button" color="primary" onClick={getCropData}>
                      Save
                    </Button>
                  </div>
                </>
              )}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    );
  } catch (err) {
    console.error(err);
  }
};

export const ReactCropperImageUpload = ({
  title,
  smallTitle,
  combined,
  value,
  onComplete,
  removeImage,
  singleUpload,
  maxImageSize,
}) => {
  const [selectedImages, setSelectedImage] = useState([]);
  const onChange = (e) => {
    e.preventDefault();
    let flag = false;
    let newUploaded = [];
    let message = "Cannot upload the same image";
    // Check if image already exists
    for (let index = 0; index < e.target.files.length; index++) {
      const selectedImage = e.target.files[index];
      // if (e.target.files[index].size > 300000) {
      //   errorAlert(
      //     "The file is too large please upload images that are less than 300 kb."
      //   );
      // } else {
      value.some((phone) => {
        if (phone.split(`${combined}-`)[1] === selectedImage.name) {
          flag = true;
        }
      });
      if (maxImageSize && selectedImage?.size > maxImageSize) {
        flag = true;
        message = `Please upload an image less than ${maxImageSize / 1000}kb.`;
      }
      if (!flag) {
        newUploaded.push(selectedImage);
      } else {
        errorAlert(message);
      }
      // }
    }
    setSelectedImage(newUploaded);
  };

  return (
    <div>
      <div className="file-lable-text pr-5">
        <div className="f16-500">{title}</div>
        <div className="f11-400 opacity5 mb-3 mt-1">{smallTitle}</div>
      </div>
      <div className="d-flex flex-wrap align-items-center">
        <div className="enUploadBox">
          <Image
            src={require("../../../assets/images/UserManagement/uploadImg.svg")}
            alt="uploadImg"
            title="uploadImg"
            fluid
          />
          <input
            type="file"
            onChange={onChange}
            // accept={accept}
            value=""
            multiple={singleUpload ? false : true}
            // disabled={disabled}
            title="Upload"
          />
        </div>
        {value?.length > 1 ? (
          <Slider {...SliderSettings} className={`sliderUploadImges`}>
            {value.map((url, index) => {
              return (
                <div
                  className="enIconUploaded"
                  key={index}
                  style={{ marginTop: "3.5rem", width: "100%" }}
                >
                  <button
                    type="button"
                    style={{ zIndex: "9" }}
                    className="remove-button-css remove-button-css-align"
                    onClick={() => {
                      removeImage(index);
                    }}
                  >
                    <CloseIcon
                      style={{
                        color: "#fff",
                        background: "#f85032",
                        fontSize: 18,
                        borderRadius: 50,
                        padding: 1,
                      }}
                    />
                  </button>
                  <Image
                    src={url}
                    alt="Document"
                    style={{ maxHeight: "110px", maxWidth: "110px" }}
                    className="rounded img-thumbnail"
                    fluid
                  />
                </div>
              );
            })}
          </Slider>
        ) : (
          value.map((url, index) => {
            return (
              <div
                className="enIconUploaded"
                key={index}
              >
                <button
                  type="button"
                  style={{ zIndex: "9" }}
                  className="remove-button-css remove-button-css-align"
                  onClick={() => {
                    removeImage(index);
                  }}
                >
                  <CloseIcon
                    style={{
                      color: "#fff",
                      background: "#f85032",
                      fontSize: 18,
                      borderRadius: 50,
                      padding: 1,
                    }}
                  />
                </button>
                <Image
                  src={url}
                  alt="Document"
                  style={{ maxHeight: "110px", maxWidth: "110px" }}
                  className="rounded img-thumbnail"
                  fluid
                />
              </div>
            );
          })
        )}
      </div>
      {selectedImages?.map((image) => {
        return (
          <ReactCropperImage
            image={image}
            key={image.name}
            onComplete={onComplete}
            combined={combined}
            value={value}
          />
        );
      })}
    </div>
  );
};
